import { useEffect } from "react";
import { ResizeObserver } from "@juggle/resize-observer";
import type { Form } from "@/react/types/Form";

const calculateContentHeight = () => {
  const body = document.body;
  const html = document.documentElement;
  return Math.max(
    body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight,
  );
};

interface UseAdjustFormHeightProps {
  form?: Form;
  index: number;
}
export const useAdjustFormHeight = ({
  form,
  index,
}: UseAdjustFormHeightProps) => {
  useEffect(() => {
    if (!form || form.embed_display_format === "popup") return;

    const resizeObserver = new ResizeObserver(() => {
      const height = calculateContentHeight();
      window.parent.postMessage(
        {
          type: "resize",
          formUid: form.uid,
          formIndex: index,
          height: `${height}px`,
        },
        "*",
      );
    });

    const formElement = document.getElementById(`form-${form.uid}`);

    if (!formElement) return;

    resizeObserver.observe(formElement);
    return () => resizeObserver.disconnect();
  }, [form, index]);

  return null;
};
